import { number } from "../../../config";
import { loadState, saveState } from "../../../shared/services/session.service";

/** Persists “All teams” scope for profile Automation tab (own profile only). */
export const USER_PROFILE_AUTOMATION_ALL_TEAMS_KEY = "userProfile_automation_all_teams_setting";

/** Dedicated sort storage so Automation profile tab does not clash with Workflows/Forms. */
export const USER_PROFILE_AUTOMATION_SORT_STORAGE_KEY = "userProfile_automation_sort_setting";

/** Sort fields: Alphabetical, Triggers (assignment analogue), Teams — no Privacy. */
export const USER_PROFILE_AUTOMATION_SORT_FIELD_OPTIONS = [
  { id: number.ONE, label: "Alphabetical" },
  { id: number.TWO, label: "Triggers" },
  { id: number.FOUR, label: "Teams" },
];

/**
 * Initial sort for profile automations; invalid “Teams” when all-teams is off is reset.
 * @param {boolean} applyAllTeamsSortRule — false when all-teams filter is not shown (admin / impersonation)
 * @author Bhavana
 */
export const readInitialAutomationSortBy = (applyAllTeamsSortRule) => {
  const persisted = loadState(USER_PROFILE_AUTOMATION_SORT_STORAGE_KEY);
  const persistedOrder = persisted?.sortOrder || "asc";
  let sortByOption = persisted?.sortBy || USER_PROFILE_AUTOMATION_SORT_FIELD_OPTIONS[number.ZERO];

  const allTeamsInStorage = loadState(USER_PROFILE_AUTOMATION_ALL_TEAMS_KEY)?.allTeamsChecked === true;
  const teamsSortInvalid = applyAllTeamsSortRule && !allTeamsInStorage && sortByOption?.id === number.FOUR;

  if (teamsSortInvalid) {
    sortByOption = USER_PROFILE_AUTOMATION_SORT_FIELD_OPTIONS[number.ZERO];
    saveState(USER_PROFILE_AUTOMATION_SORT_STORAGE_KEY, { sortBy: sortByOption, sortOrder: persistedOrder });
  }

  return sortByOption;
};
